<template>
  <div>
    <div>
      <div class="info row gy-1 info-edit min-hgt" v-if="!renderBillingInfo">
        <!-- user name -->
        <div v-if="billingInfo.payment_method == 'cc'">
          <div class="row  justify-content-between" >
          <span class=" info-display info-name col-lg-6 col-md-6 col-sm-6" v-if="billingInfo.first_name_on_cc">
                 {{billingInfo.first_name_on_cc}} {{billingInfo.last_name_on_cc}}
          </span>

          </div>

          <div class="col-12 mb-2 mt-2" v-if="billingInfo.payment_method">
          <span class="">
            <strong>Payment Method:</strong> {{billingInfo.payment_method.toUpperCase()}}
          </span>
          </div>

          <div class="col-12 mb-2" v-if="billingInfo.card_number">
          <span class="">
            <strong>Card Number:</strong> {{billingInfo.card_number}}
          </span>
          </div>

          <div class="col-12 mb-2" v-if="billingInfo.expiration_month">
          <span class="">
            <strong>Expiration Month:</strong> {{billingInfo.expiration_month}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.expiration_year">
          <span class="">
            <strong>Expiration Year:</strong> {{billingInfo.expiration_year}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.city">
            <span class="">
              <strong>City:</strong> {{billingInfo.city}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.address1">
          <span class="">
            <strong>Address1:</strong> {{billingInfo.address1}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.address2">
          <span class="">
            <strong>Address2:</strong> {{billingInfo.address2}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.security_code">
          <span class="">
            <strong>Security Code:</strong> {{billingInfo.security_code}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.zip">
          <span class="">
            <strong>Zip:</strong> {{billingInfo.zip}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.state">
          <span class="">
            <strong>State:</strong> {{billingInfo.state}}
          </span>
          </div>
          <div class="">
            <button @click="renderBillingInfo = true"
                    class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100"
            >
              <i class="fas fa-pen me-2"></i>
              Edit Details
            </button>
          </div>
        </div>
        <div v-else>
          <div class=" row  justify-content-between" >
          <span class=" info-display info-name col-lg-6 col-md-6 col-sm-6 ms-1 ps-2 mb-2" v-if="billingInfo.account_name">
                 {{billingInfo.account_name}}
          </span>

          </div>

          <div class="col-12 mb-2" v-if="billingInfo.payment_method">
          <span class="">
            <strong>Payment Method:</strong> {{billingInfo.payment_method.toUpperCase()}}
          </span>
          </div>

          <div class="col-12 mb-2" v-if="billingInfo.account_number">
          <span class="">
            <strong>Account Number:</strong> {{billingInfo.account_number}}
          </span>
          </div>

          <div class="col-12 mb-2" v-if="billingInfo.routing_number">
          <span class="">
            <strong>Routing Number:</strong> {{billingInfo.routing_number}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.bank_name">
            <span class="">
              <strong>Bank Name:</strong> {{billingInfo.bank_name}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.account_type">
          <span class="">
            <strong>Account Type:</strong> {{billingInfo.account_type}}
          </span>
          </div>
          <div class="col-12 mb-2" v-if="billingInfo.account_holder_type">
          <span class="">
            <strong>Account Holder Type:</strong> {{billingInfo.account_holder_type.toUpperCase()}}
          </span>
          </div>
          <div class="">
            <button @click="renderBillingInfo = true"
                    class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100"
            >
              <i class="fas fa-pen me-2"></i>
              Edit Details
            </button>
          </div>
        </div>

      </div>
    </div>
    <div v-if="renderBillingInfo">
      <billing-information :isRedirectionFromReview="true"
                           @cancelEditInfo="cancelEditInfo"
                           @updatedEditInfo="updatedEditInfo"/>
    </div>
  </div>
</template>

<script>
import BillingInformation from "../BillingInformation";
export default {
  name: "BillingInfoEdit",
  props: {
    billingInfo: {
      type: Object
    }
  },
  data () {
    return {
      renderBillingInfo: false
    }
  },
  components: {
    BillingInformation
  },
  methods: {
    cancelEditInfo () {
      let app = this
      app.renderBillingInfo = false
    },
    updatedEditInfo () {
      let app = this
      app.renderBillingInfo = false
      app.$emit('updatedEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped>
</style>